import { Transition } from '@headlessui/react'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as Yup from "yup";
import React, { useEffect, useState } from 'react'

export default function EducatorExportReport({ openExportReport, setOpenExportReport }) {

    const [initialValues, setInitialValues] = useState({
        classGroupSelect: "",
        studentSelector: "",
        application: "",
        startDate: "",
        endDate: "",
        reportType: [],
        fileFormat: 'Pdf'
    });

    const validationSchema = Yup.object({
        classGroupSelect: Yup.string().required("Select class / group"),
        studentSelector: Yup.string().required("Select student"),
        application: Yup.string().required("Select application"),
        startDate: Yup.date()
            .required('Select start date'),
        endDate: Yup.date()
            .required('Select end date'),
        reportType: Yup.array()
            .min(1, "Select at least one role") // require at least one selection
            .required("Select report type"),
    });

    const handleSubmit = async (values, resetForm) => {
        try {

        } catch (e) {
        }
    };

    return (
        <Transition show={openExportReport}>
            <div className="fixed inset-0 z-50 flex justify-end">
                {/* Overlay */}
                <div
                    className="fixed inset-0 bg-black bg-opacity-50"
                    onClick={() => setOpenExportReport(false)}
                ></div>

                {/* Offcanvas Panel */}
                <div className="relative bg-white w-full max-w-[650px] h-full shadow-lg p-6">
                    {/* Header */}
                    <div className="flex justify-between items-center  pb-3">
                        <h2 className="text-[22px] font-bold text-primary-900">
                            Export Reports
                        </h2>
                        <button
                            className="text-gray-500 hover:text-gray-800"
                            onClick={() => setOpenExportReport(false)}
                        >
                            ✕
                        </button>
                    </div>

                    {/* Body */}
                    <div className='mt-3 overflow-y-auto h-[calc(100vh-100px)]' style={{ scrollbarWidth: 'none' }}>
                        <Formik
                            initialValues={initialValues}
                            enableReinitialize={true}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ setFieldValue }) => (
                                <Form >
                                    <div>
                                        <label className="text-md text-[#717576] font-normal">
                                            Class / Group Selector
                                        </label>
                                        <div className="relative">
                                            <Field
                                                as="select"
                                                name="classGroupSelect"
                                                className="w-full border py-2 px-4 text-md my-[9px] h-[60px] rounded-[10px] appearance-none pr-10 focus:outline-none focus-visible:outline-none"
                                            >
                                                <option value="">Select</option>
                                            </Field>

                                            {/* Custom dropdown arrow */}
                                            <svg
                                                width="20"
                                                height="11"
                                                viewBox="0 0 20 11"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                            >
                                                <path d="M10 11L0 0L20 0L10 11Z" fill="black" />
                                            </svg>
                                        </div>
                                        <ErrorMessage
                                            name="classGroupSelect"
                                            component="div"
                                            className="text-red-500 text-sm"
                                        />
                                    </div>
                                    <div className='mt-2'>
                                        <label className="text-md text-[#717576] font-normal">
                                            Student Selector
                                        </label>
                                        <div className="relative">
                                            <Field
                                                as="select"
                                                name="studentSelector"
                                                className="w-full border py-2 px-4 text-md my-[9px] h-[60px] rounded-[10px] appearance-none pr-10 focus:outline-none focus-visible:outline-none"
                                            >
                                                <option value="">Select</option>
                                            </Field>

                                            {/* Custom dropdown arrow */}
                                            <svg
                                                width="20"
                                                height="11"
                                                viewBox="0 0 20 11"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                            >
                                                <path d="M10 11L0 0L20 0L10 11Z" fill="black" />
                                            </svg>
                                        </div>
                                        <ErrorMessage
                                            name="studentSelector"
                                            component="div"
                                            className="text-red-500 text-sm"
                                        />
                                    </div>
                                    <div className='mt-2'>
                                        <label className="text-md text-[#717576] font-normal">
                                            Application
                                        </label>
                                        <div className="relative">
                                            <Field
                                                as="select"
                                                name="application"
                                                className="w-full border py-2 px-4 text-md my-[9px] h-[60px] rounded-[10px] appearance-none pr-10 focus:outline-none focus-visible:outline-none"
                                            >
                                                <option value="">Select</option>
                                            </Field>

                                            {/* Custom dropdown arrow */}
                                            <svg
                                                width="20"
                                                height="11"
                                                viewBox="0 0 20 11"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                            >
                                                <path d="M10 11L0 0L20 0L10 11Z" fill="black" />
                                            </svg>
                                        </div>
                                        <ErrorMessage
                                            name="application"
                                            component="div"
                                            className="text-red-500 text-sm"
                                        />
                                    </div>
                                    <div className='mt-2'>
                                        <label className="text-md text-[#717576] font-normal">
                                            Date Range
                                        </label>
                                        <div className='flex items-center gap-3'>
                                            <div className='w-full'>
                                                <Field
                                                    name="startDate"
                                                    type="date"
                                                    className="w-full text-[#717576] border border-[#717576] p-3 my-[9px] h-[60px] rounded-[10px]"
                                                />
                                                <ErrorMessage
                                                    name="startDate"
                                                    component="div"
                                                    className="text-red-500 text-sm"
                                                />
                                            </div>
                                            <label className="text-md text-[#717576] font-normal">
                                                to
                                            </label>
                                            <div className='w-full'>
                                                <Field
                                                    name="endDate"
                                                    type="date"
                                                    className="w-full text-[#717576] border border-[#717576] p-3 my-[9px] h-[60px] rounded-[10px]"
                                                />

                                                <ErrorMessage
                                                    name="endDate"
                                                    component="div"
                                                    className="text-red-500 text-sm"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mt-2'>
                                        <label className="text-md text-[#717576] font-normal">
                                            Report Type
                                        </label>
                                        <div className='space-y-3 border rounded-[16px] p-6 bg-white shadow-sm mt-2'>
                                            <label className='flex items-center py-1 gap-2 text-gray-500 cursor-pointer'>
                                                <Field type="checkbox" name="reportType" value="PerformanceSummary" className='mr-2 w-4 h-4' />
                                                <span className='text-[#283C50]'>Performance Summary</span> → Grades, progress trends, badges
                                            </label>
                                            <label className='flex items-center py-1 gap-2 text-gray-500 cursor-pointer'>
                                                <Field type="checkbox" name="reportType" value="UsageStatistics" className='mr-2 w-4 h-4' />
                                                <span className='text-[#283C50]'>Usage Statistics</span> → Time spent, sessions, app usage
                                            </label>
                                            <label className='flex items-center py-1 gap-2 text-gray-500 cursor-pointer'>
                                                <Field type="checkbox" name="reportType" value="NotesandGrade" className='mr-2 w-4 h-4' />
                                                <span className='text-[#283C50]'>Notes & Grades Log</span> → Linked educator notes, remarks, grades
                                            </label>
                                            <label className='flex items-center py-1 gap-2 text-gray-500 cursor-pointer'>
                                                <Field type="checkbox" name="reportType" value="FullReport" className='mr-2 w-4 h-4' />
                                                <span className='text-[#283C50]'>Full Report (All Data)</span> → Comprehensive export
                                            </label>
                                        </div>
                                        <ErrorMessage
                                            name="reportType"
                                            component="div"
                                            className="text-red-500 text-sm"
                                        />
                                    </div>

                                    <div className='mt-2'>
                                        <label className="text-md text-[#717576] font-normal">
                                            File Format Selection
                                        </label>
                                        <div className='space-y-3 border rounded-[16px] p-6 bg-white shadow-sm mt-2'>
                                            <label className='flex items-center py-1 gap-2 text-gray-500 cursor-pointer'>
                                                <Field type="radio" name="fileFormat" value="Pdf" className='mr-2 w-4 h-4' />
                                                PDF (formatted for presentation)
                                            </label>
                                            <label className='flex items-center py-1 gap-2 text-gray-500 cursor-pointer'>
                                                <Field type="radio" name="fileFormat" value="Csv" className='mr-2 w-4 h-4' />
                                                CSV (raw data for analysis)
                                            </label>
                                        </div>
                                    </div>

                                    <div className="flex justify-between gap-3 pt-4">
                                        <button
                                            type="button"
                                            onClick={() => setOpenExportReport(false)}
                                            className="px-4 py-4 w-full rounded-[10px] border border-brandBlue text-brandBlue bg-transparent hover:bg-brandBlue hover:text-white transition"
                                        >
                                            Save as Template
                                        </button>

                                        <button
                                            type="submit"
                                            className="px-4 py-4 w-full rounded-[10px] bg-brandBlue text-white hover:bg-primary-700 transition btn-primary"
                                        >
                                            Generate & Download
                                        </button>
                                        <button
                                            type="submit"
                                            className="px-4 py-4 w-[100px] rounded-[10px] bg-[#283C50] text-white hover:bg-[#283C50] transition btn-primary"
                                        >
                                            <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16 4H4V0H16V4ZM16 9.5C16.2833 9.5 16.521 9.404 16.713 9.212C16.905 9.02 17.0007 8.78267 17 8.5C16.9993 8.21733 16.9033 7.98 16.712 7.788C16.5207 7.596 16.2833 7.5 16 7.5C15.7167 7.5 15.4793 7.596 15.288 7.788C15.0967 7.98 15.0007 8.21733 15 8.5C14.9993 8.78267 15.0953 9.02033 15.288 9.213C15.4807 9.40567 15.718 9.50133 16 9.5ZM14 16V12H6V16H14ZM16 18H4V14H0V8C0 7.15 0.291667 6.43767 0.875 5.863C1.45833 5.28833 2.16667 5.00067 3 5H17C17.85 5 18.5627 5.28767 19.138 5.863C19.7133 6.43833 20.0007 7.15067 20 8V14H16V18Z" fill="white" />
                                            </svg>

                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </Transition>
    )
}
